import { setLocalStorage } from "utils/localStorage";

export const baseURL = process.env.REACT_APP_API_URL + "api";

export const urls = {
	USER_ENDPOINT: "user",
	BASIC_LOGIN_ENDPOINT: "auth/login/basic/admin",
	CHECK_TOKEN_ENDPOINT: "auth/admin-check-token",
	ADD_POINTS_ENDPOINT: "user/add-points",
	UPLOAD_ENDPOINT: "upload",
	MENU_ENDPOINT: "menu",
	TRANSACTION_ENDPOINT: "transaction",
	ORDER_ENDPOINT: "order",
	ROLE_ENDPOINT: "role",
	STAFF_ENDPOINT: "admin",
	COURSE_ENDPOINT: "course",
	ATTENDANCE_ENDPOINT: "attendance",
	STUDENT_ENDPOINT: "student",
	LEAVE_ENDPOINT: "application/leave",
	OT_ENDPOINT: "application/ot",
	STAFF_APPLICATION_ENDPOINT: "application",
	LESSON_RECORD_ENDPOINT: "lesson_record",
	STAFF_AVAILABILITY_ENDPOINT: "admin/availability",
};

export const errorMessageParser = (error) => {
	return JSON.stringify(error.response?.data?.detail || error.response?.data?.message || error.message);
};

export const errorHandler = (error) => {
	throw new Error(errorMessageParser(error));
};

export const httpHandler = (apiCall) =>
	apiCall()
		.then((response) => response.data)
		.catch((error) => {
			if (error.response === 403) return cleanup();
			throw new Error(errorMessageParser(error));
		});

export const cleanup = () => {
	if (!window.navigator.onLine) return;
	setLocalStorage("authToken", "");
	const url = new URL(window.location.href);
	url.searchParams.delete("redirect");
	url.searchParams.set("redirect", window.location.href);
	window.location.assign(process.env.REACT_APP_BASE_URL + `?${url.searchParams.toString()}`);
};

export const buildQueryParams = (data) =>
	data
		? Object.entries(data)
				.map(([key, val]) =>
					typeof val === "boolean"
						? encodeURIComponent(key) + "=" + encodeURIComponent(val)
						: val
						? encodeURIComponent(key) + "=" + encodeURIComponent(val)
						: ""
				)
				.join("&")
		: "";
